<template>
    <div>
        <v-alert type="info" border="left" colored-border>
            Buat akun atau masuk untuk melanjutkan
        </v-alert>

        <v-tabs v-model="tab" grow>
            <v-tab>Daftar</v-tab>
            <v-tab>Masuk</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item>
                <signup-form @submit="signup" class="pa-4"></signup-form>
            </v-tab-item>
            <v-tab-item>
                <login-form @submit="login" class="pa-4"></login-form>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
import SignupForm from '@/components/auth/SignupForm'
import LoginForm from '@/components/auth/LoginForm'
import { sync } from 'vuex-pathify'
import {  USER_JOIN } from '@/store/groupjoin'

export default {
    components: {
        SignupForm,
        LoginForm
    },

    data() {
        return {
            tab: null
        }
    },

    computed: {
        ...sync('home', ['credential', 'loginPassword', 'error']),
        ...sync('groupjoin/*'),
    },

    methods: {
        signup() {
            const data = {
                ...this.$store.get('home/signupData'),
                group_hash: this.$route.params.group_hash
            }
            const endpoint = 'auth/signupAndJoinGroup'

            this.$store.dispatch('auth/signup', { data, endpoint })
                .then(() => {
                    this.$router.replace({ name: this.groupRoute })
                })
        },

        login() {
            this.$store.dispatch('auth/login', {
                data: {
                    credential: this.credential,
                    password: this.loginPassword
                }
            })
                .then(response => {
                    if (response.data.group_hash) {
                        if (response.data.group_hash === this.groupHash) {
                            // User already join the group
                            this.$router.replace({ name: this.groupRoute })
                        } else {
                            // User can join group or already join other group
                            this.getAuthData()
                                .then(() => this.status = USER_JOIN)
                        }
                    } else {
                        this.getAuthData()
                            .then(() => this.status = USER_JOIN)
                    }
                })
        },

        getAuthData() {
            return new Promise((resolve, reject) => {
                this.$api.get('auth')
                    .then(response => {
                        this.$store.dispatch('auth/setDataFromAuth', response.data)
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
    }
}
</script>
